/** Available filter categories for browsing resources. */
export const CATEGORIES = [
  "All",
  "Visual Communication",
  "Motion Graphics",
  "UX/UI & Web Design",
  "Animation & 3D Arts",
  "Media Production",
  "Photography",
  "Video Editing",
  "Videography"
];

/** Curated collection of learning materials, tools, templates, gigs, communities, and scenario guides. */
export const resourceData = [
  // LEARNING
  {
    id: "l1",
    title: "Typography & Layout Fundamentals",
    description: "Learn spacing, hierarchy, and font pairing fundamentals in a concise interactive lesson (Canva Design School).",
    type: "Learning",
    category: "Visual Communication",
    link: "https://www.canva.com/design-school/courses/typography-and-layout",
    icon: "Type",
    tags: ["Typography", "Layout", "Basics"],
    tier: "essential",
  },
  {
    id: "l2",
    title: "Understanding Typography Theory",
    description: "Beginner-friendly Canva lesson on identifying & pairing typefaces, building visual hierarchy, and aligning text for impact.",
    type: "Learning",
    category: "Visual Communication",
    link: "https://www.canva.com/design-school/lessons/understanding-typography-theory",
    icon: "Ruler",
    tags: ["Typography", "Readability", "Basics"],
  },
  {
    id: "l3",
    title: "After Effects Beginner Guide",
    description: "Adobe's official After Effects user guide covering the interface, timeline, and animation basics (updated 2026).",
    type: "Learning",
    category: "Motion Graphics",
    link: "https://helpx.adobe.com/after-effects/user-guide.html",
    icon: "Film",
    tags: ["After Effects", "Basics"],
    tier: "essential",
  },
  {
    id: "l4",
    title: "Blender Beginner Manual",
    description: "Official Blender documentation for modeling, lighting, animation and rendering workflows (free 3D suite).",
    type: "Learning",
    category: "Animation & 3D Arts",
    link: "https://docs.blender.org/manual/en/latest/",
    icon: "Box",
    tags: ["Blender", "3D"],
  },
  {
    id: "l5",
    title: "Figma Auto Layout Guide",
    description: "Figma's help guide on Auto Layout and responsive design so your interface adapts correctly in use.",
    type: "Learning",
    category: "UX/UI & Web Design",
    link: "https://help.figma.com/hc/en-us/articles/360040451373-Guide-to-auto-layout",
    icon: "LayoutTemplate",
    tags: ["Figma", "Responsive"],
    tier: "essential",
  },
  {
    id: "l6",
    title: "Premiere Pro Editing Basics",
    description: "Adobe's official Premiere Pro workflow guide: timeline editing, cuts, transitions, and exporting clean videos.",
    type: "Learning",
    category: "Video Editing",
    link: "https://helpx.adobe.com/premiere-pro/using/basic-workflow.html",
    icon: "Scissors",
    tags: ["Editing", "Video"],
  },
  {
    id: "l7",
    title: "School of Motion: Path to MoGraph",
    description: "Free 2-hour intro course to motion design. Covers brainstorming, animating in After Effects, sound, and delivery.",
    type: "Learning",
    category: "Motion Graphics",
    link: "https://www.schoolofmotion.com/courses/path-to-mograph",
    icon: "GraduationCap",
    tags: ["Motion Design", "Overview"],
    tier: "pro",
  },
  {
    id: "l8",
    title: "Refactoring UI",
    description: "Learn to design beautiful user interfaces with developer-friendly tactics (visual design book + videos).",
    type: "Learning",
    category: "UX/UI & Web Design",
    link: "https://www.refactoringui.com/",
    icon: "Palette",
    tags: ["UI", "Tactics"],
    tier: "pro",
  },
  {
    id: "l9",
    title: "Cinematography Basics",
    description: "StudioBinder blog guide on lighting, framing and camera theory for better video shoot planning.",
    type: "Learning",
    category: "Videography",
    link: "https://www.studiobinder.com/category/directing/cinematography/",
    icon: "Camera",
    tags: ["Cinematography", "Lighting"],
  },
  {
    id: "l10",
    title: "Logo Design Principles",
    description: "Guide by 99designs on designing memorable, scalable logos – covering brand research, simplicity, and color theory.",
    type: "Learning",
    category: "Visual Communication",
    link: "https://99designs.com/blog/logo-branding/how-to-design-logo/",
    icon: "PenTool",
    tags: ["Logo", "Branding"],
  },
  {
    id: "l11",
    title: "Substance 3D Painter Tutorials",
    description: "Adobe's official Getting Started tutorials for Substance 3D Painter (project setup and texture painting).",
    type: "Learning",
    category: "Animation & 3D Arts",
    link: "https://experienceleague.adobe.com/en/docs/substance-3d-painter/using/getting-started/getting-started",
    icon: "Brush",
    tags: ["Texturing", "Materials"],
  },
  {
    id: "l12",
    title: "AI Prompting for Video Creators",
    description: "Master the art of prompting to generate scripts, storyboards, and visual assets using AI (Prompt Library).",
    type: "Learning",
    category: "Video Editing",
    link: "https://promptlibrary.org/",
    icon: "Wand2",
    tags: ["AI", "Prompting", "Video"],
  },
  {
    id: "l13",
    title: "Mastering CapCut: Desktop & Mobile",
    description: "Learn advanced editing, keyframing, and speed ramping techniques in CapCut for viral content.",
    type: "Learning",
    category: "Video Editing",
    link: "https://www.capcut.com/resource/",
    icon: "Video",
    tags: ["CapCut", "Editing"],
  },
  {
    id: "l14",
    title: "Photography Exposure Triangle",
    description: "A deep dive into ISO, Shutter Speed, and Aperture to take full manual control of your camera.",
    type: "Learning",
    category: "Photography",
    link: "https://photographylife.com/what-is-exposure-triangle",
    icon: "Sun",
    tags: ["Photography", "Basics"],
  },
  {
    id: "l15",
    title: "Essential Camera Movements",
    description: "A guide to pans, tilts, dollies, and more to add cinematic flair to your video projects.",
    type: "Learning",
    category: "Videography",
    link: "https://www.studiobinder.com/blog/camera-movements-in-film/",
    icon: "Video",
    tags: ["Camera", "Cinematic"],
  },
  {
    id: "l16",
    title: "The Art of Portrait Lighting",
    description: "Learn to manipulate natural and artificial light to create depth and emotion in your photography.",
    type: "Learning",
    category: "Photography",
    link: "https://www.creativelive.com/photography/portrait",
    icon: "Sun",
    tags: ["Lighting", "Portrait"],
  },
  {
    id: "l17",
    title: "Laws of UX",
    description: "Bite-sized psychology principles for interface design — Hick’s Law, Fitts’s Law, aesthetic-usability, and more.",
    type: "Learning",
    category: "UX/UI & Web Design",
    link: "https://lawsofux.com/",
    icon: "Lightbulb",
    tags: ["UX", "Psychology", "Principles"],
    tier: "essential",
  },
  {
    id: "l18",
    title: "Practical Typography",
    description: "Matthew Butterick’s free online book on type, spacing, and layout decisions that make work look professional.",
    type: "Learning",
    category: "Visual Communication",
    link: "https://practicaltypography.com/",
    icon: "Type",
    tags: ["Typography", "Craft"],
    tier: "pro",
  },
  {
    id: "l19",
    title: "Learn CSS (web.dev)",
    description: "Google’s free, modern CSS curriculum — layout, responsive design, and accessibility for UI freelancers.",
    type: "Learning",
    category: "UX/UI & Web Design",
    link: "https://web.dev/learn/css",
    icon: "Code2",
    tags: ["CSS", "Web", "Free"],
    tier: "essential",
  },
  {
    id: "l20",
    title: "Cambridge in Colour",
    description: "Clear photography tutorials on exposure, color, sharpness, and composition — excellent for freelancers leveling up craft.",
    type: "Learning",
    category: "Photography",
    link: "https://www.cambridgeincolour.com/tutorials.htm",
    icon: "Camera",
    tags: ["Photography", "Theory"],
    tier: "pro",
  },

  // TOOLS
  {
    id: "t1",
    title: "Figma",
    description: "Industry-standard UI/UX design and prototyping tool (browser-based, collaborative, free tier available).",
    type: "Tools",
    category: "UX/UI & Web Design",
    link: "https://www.figma.com/",
    icon: "Figma",
    tags: ["UI", "Design"],
    tier: "essential",
  },
  {
    id: "t2",
    title: "Blender",
    description: "Free, powerful 3D modeling and animation software for artists and studios.",
    type: "Tools",
    category: "Animation & 3D Arts",
    link: "https://www.blender.org/",
    icon: "Cuboid",
    tags: ["3D", "Free"],
    tier: "essential",
  },
  {
    id: "t3",
    title: "Vercel",
    description: "Deploy front-end web projects instantly with global CDN and zero configuration.",
    type: "Tools",
    category: "UX/UI & Web Design",
    link: "https://vercel.com/",
    icon: "Triangle",
    tags: ["Hosting", "Deploy"],
  },
  {
    id: "t4",
    title: "Notion",
    description: "All-in-one workspace to organize clients, projects, tasks and notes. Many templates available.",
    type: "Tools",
    category: "Media Production",
    link: "https://www.notion.com/",
    icon: "BookMarked",
    tags: ["Productivity", "CRM"],
  },
  {
    id: "t5",
    title: "Wave (Invoicing)",
    description: "Free invoicing and accounting software. Saves you time, gets you paid, and makes managing customer information easier.",
    type: "Tools",
    category: "Media Production",
    link: "https://www.waveapps.com/",
    icon: "Receipt",
    tags: ["Invoices", "Payments"],
    tier: "essential",
  },
  {
    id: "t6",
    title: "Adobe Illustrator",
    description: "Industry-standard vector graphics editor for logos, icons and illustrations.",
    type: "Tools",
    category: "Visual Communication",
    link: "https://www.adobe.com/products/illustrator.html",
    icon: "Spline",
    tags: ["Vector", "Design"],
    tier: "pro",
  },
  {
    id: "t7",
    title: "Cavalry",
    description: "Free 2D motion-graphics software by Scene Group. Makes 2D animation smarter, easier and faster to produce.",
    type: "Tools",
    category: "Motion Graphics",
    link: "https://cavalry.scenegroup.co/",
    icon: "Waypoints",
    tags: ["2D", "Procedural"],
    tier: "hidden-gem",
  },
  {
    id: "t8",
    title: "Milanote",
    description: "Visual organization tool for creative projects. Great for moodboards and planning.",
    type: "Tools",
    category: "Visual Communication",
    link: "https://milanote.com/",
    icon: "PinIcon",
    tags: ["Moodboards", "Planning"],
  },
  {
    id: "t9",
    title: "DaVinci Resolve",
    description: "Free professional video editing, color grading, and VFX suite (used in film and TV post-production).",
    type: "Tools",
    category: "Video Editing",
    link: "https://www.blackmagicdesign.com/products/davinciresolve",
    icon: "Clapperboard",
    tags: ["Video Editing", "Color Grading"],
  },
  {
    id: "t10",
    title: "Rive",
    description: "Interactive animation engine (used by Spotify, Duolingo, etc.). Build animations that run natively in apps, games or web.",
    type: "Tools",
    category: "Motion Graphics",
    link: "https://rive.app/",
    icon: "Zap",
    tags: ["Interactive", "Animation"],
    tier: "hidden-gem",
  },
  {
    id: "t11",
    title: "CapCut",
    description: "The most popular all-in-one video editor for creators. Simple enough for beginners, powerful enough for pros.",
    type: "Tools",
    category: "Video Editing",
    link: "https://www.capcut.com/",
    icon: "Scissors",
    tags: ["Video Editing", "Free"],
  },
  {
    id: "t12",
    title: "Darkroom",
    description: "Advanced photo and video editor for mobile and desktop, featuring RAW support and deep integration.",
    type: "Tools",
    category: "Photography",
    link: "https://darkroom.co/",
    icon: "Image",
    tags: ["Photography", "Editing"],
  },
  {
    id: "t13",
    title: "Storyboarder",
    description: "Free, open-source tool for quickly sketching and organizing storyboards for video and animation.",
    type: "Tools",
    category: "Videography",
    link: "https://wonderunit.com/storyboarder/",
    icon: "PenTool",
    tags: ["Planning", "Pre-production"],
    tier: "hidden-gem",
  },
  {
    id: "t14",
    title: "Sun Surveyor",
    description: "Plan your outdoor shoots with precision by tracking sun and moon positions and golden hour times.",
    type: "Tools",
    category: "Videography",
    link: "https://www.sunsurveyor.com/",
    icon: "Sun",
    tags: ["Planning", "Outdoor"],
    tier: "hidden-gem",
  },
  {
    id: "t15",
    title: "Adobe Lightroom",
    description: "The professional standard for non-destructive photo editing and organization.",
    type: "Tools",
    category: "Photography",
    link: "https://www.adobe.com/products/photoshop-lightroom.html",
    icon: "Image",
    tags: ["Photo Editing", "Workflow"],
  },
  {
    id: "t16",
    title: "Penpot",
    description: "Open-source, self-hostable alternative to Figma for UI design and prototyping — free forever for teams.",
    type: "Tools",
    category: "UX/UI & Web Design",
    link: "https://penpot.app/",
    icon: "Layers",
    tags: ["Open Source", "UI", "Free"],
    tier: "hidden-gem",
  },
  {
    id: "t17",
    title: "Photopea",
    description: "Browser-based Photoshop-compatible editor. Open PSD/AI files and ship retouches without a subscription.",
    type: "Tools",
    category: "Visual Communication",
    link: "https://www.photopea.com/",
    icon: "Image",
    tags: ["Raster", "Free", "Browser"],
    tier: "essential",
  },
  {
    id: "t18",
    title: "Krita",
    description: "Professional free digital painting app for illustration, concept art, and 2D animation.",
    type: "Tools",
    category: "Visual Communication",
    link: "https://krita.org/",
    icon: "Brush",
    tags: ["Illustration", "Free", "Painting"],
    tier: "essential",
  },
  {
    id: "t19",
    title: "Spline",
    description: "Design interactive 3D scenes in the browser and export for web/product work — great for modern portfolios.",
    type: "Tools",
    category: "Animation & 3D Arts",
    link: "https://spline.design/",
    icon: "Box",
    tags: ["3D", "Web", "Interactive"],
    tier: "pro",
  },
  {
    id: "t20",
    title: "LottieFiles",
    description: "Find, edit, and ship lightweight Lottie animations for apps and websites — industry standard for micro-motion.",
    type: "Tools",
    category: "Motion Graphics",
    link: "https://lottiefiles.com/",
    icon: "Zap",
    tags: ["Lottie", "Motion", "Web"],
    tier: "pro",
  },
  {
    id: "t21",
    title: "Coolors",
    description: "Generate and export accessible color palettes in seconds — fast brand and UI color exploration.",
    type: "Tools",
    category: "Visual Communication",
    link: "https://coolors.co/",
    icon: "Palette",
    tags: ["Color", "Branding"],
  },
  {
    id: "t22",
    title: "Fontshare",
    description: "Quality free fonts from Indian Type Foundry with clear commercial licenses — portfolio-safe type.",
    type: "Tools",
    category: "Visual Communication",
    link: "https://www.fontshare.com/",
    icon: "Type",
    tags: ["Fonts", "Free", "Typography"],
    tier: "hidden-gem",
  },
  {
    id: "t23",
    title: "OBS Studio",
    description: "Free open-source software for recording and live streaming — essential for demos, courses, and client walkthroughs.",
    type: "Tools",
    category: "Videography",
    link: "https://obsproject.com/",
    icon: "Video",
    tags: ["Recording", "Streaming", "Free"],
    tier: "essential",
  },
  {
    id: "t24",
    title: "Toggl Track",
    description: "Simple time tracking so you know what hours go where — and can price projects with real data.",
    type: "Tools",
    category: "Media Production",
    link: "https://toggl.com/track/",
    icon: "Timer",
    tags: ["Time Tracking", "Business"],
    tier: "essential",
  },
  {
    id: "t25",
    title: "Cal.com",
    description: "Open-source scheduling (Calendly alternative). Let clients book discovery calls without email ping-pong.",
    type: "Tools",
    category: "Media Production",
    link: "https://cal.com/",
    icon: "Compass",
    tags: ["Scheduling", "Clients"],
    tier: "pro",
  },
  {
    id: "t26",
    title: "Unsplash",
    description: "High-quality free stock photos with clear licenses — useful for comps, moodboards, and client mockups.",
    type: "Tools",
    category: "Photography",
    link: "https://unsplash.com/",
    icon: "Camera",
    tags: ["Stock", "Free", "Photos"],
  },

  // TEMPLATES
  {
    id: "temp1",
    title: "Freelance Contract Template",
    description: "Simple contract covering scope, revisions and payment terms, protecting you from scope creep and non-payment.",
    type: "Templates",
    category: "Media Production",
    link: "https://www.hellobonsai.com/contract-template/freelance",
    icon: "FileSignature",
    tags: ["Contract", "Legal"],
    tier: "essential",
  },
  {
    id: "temp2",
    title: "Invoice Template",
    description: "Clean, professional invoice you can customize and send to clients without fuss.",
    type: "Templates",
    category: "Media Production",
    link: "https://www.hubspot.com/resources/templates/basic-invoice",
    icon: "FileText",
    tags: ["Invoice", "Billing"],
    tier: "essential",
  },
  {
    id: "temp3",
    title: "Notion Freelancer Workspace",
    description: "Free Notion template to track projects, deadlines and client communications in one dashboard.",
    type: "Templates",
    category: "Media Production",
    link: "https://www.notion.com/templates/freelancer-project-management",
    icon: "LayoutDashboard",
    tags: ["Tracking", "Workflow"],
  },
  {
    id: "temp4",
    title: "Figma UI Starter Templates",
    description: "Set of Figma template files (UI kits and components) to jumpstart UI design projects without starting from scratch.",
    type: "Templates",
    category: "UX/UI & Web Design",
    link: "https://www.figma.com/templates/",
    icon: "Layers",
    tags: ["UI", "Starter"],
  },
  {
    id: "temp5",
    title: "Brand Guidelines Deck",
    description: "Envato presentation template for showcasing brand identity and usage guidelines to clients.",
    type: "Templates",
    category: "Visual Communication",
    link: "https://elements.envato.com/presentation-templates/brand-guidelines",
    icon: "BookOpen",
    tags: ["Brand Guide", "Presentation"],
  },
  {
    id: "temp6",
    title: "Storyboard Template",
    description: "Printable/digital storyboard frames for planning video shots or animation scenes.",
    type: "Templates",
    category: "Motion Graphics",
    link: "https://boords.com/storyboard-templates",
    icon: "GalleryHorizontal",
    tags: ["Planning", "Animation"],
  },
  {
    id: "temp7",
    title: "3-Point Lighting Setup (Blender)",
    description: "Free Blender file with a standard three-light studio setup – ready to drop into your 3D scenes for polished lighting.",
    type: "Templates",
    category: "Animation & 3D Arts",
    link: "https://blendswap.com/blend/2178",
    icon: "Lightbulb",
    tags: ["Lighting", "Rendering"],
    tier: "hidden-gem",
  },
  {
    id: "temp8",
    title: "Website Wireframe Kits (Figma)",
    description: "Low-fidelity website wireframe and layout components in Figma to sketch UX flows quickly before design.",
    type: "Templates",
    category: "UX/UI & Web Design",
    link: "https://www.figma.com/community/wireframes",
    icon: "Layout",
    tags: ["Wireframing", "Layout"],
  },
  {
    id: "temp9",
    title: "Video Production Script",
    description: "Standard two-column script template for planning visuals and audio cues for your video projects.",
    type: "Templates",
    category: "Video Editing",
    link: "https://www.studiobinder.com/blog/video-script-template/",
    icon: "FileText",
    tags: ["Script", "Planning"],
  },
  {
    id: "temp10",
    title: "Photography Shot List",
    description: "Stay organized on set with a detailed list of all the shots you need to capture during your session.",
    type: "Templates",
    category: "Photography",
    link: "https://www.format.com/magazine/resources/photography/photography-shot-list-template",
    icon: "ListChecks",
    tags: ["Shot List", "Organization"],
  },

  // GIGS
  {
    id: "g1",
    title: "Upwork",
    description: "One of the largest freelance marketplaces (design, web, marketing, etc.) with thousands of new projects daily.",
    type: "Gigs",
    category: "UX/UI & Web Design",
    link: "https://www.upwork.com/",
    icon: "Briefcase",
    tags: ["Freelance", "Remote"],
  },
  {
    id: "g2",
    title: "Contra",
    description: "Commission-free creative platform where designers and creators connect directly with clients.",
    type: "Gigs",
    category: "Visual Communication",
    link: "https://contra.com/",
    icon: "Compass",
    tags: ["No Fees", "Creative"],
  },
  {
    id: "g3",
    title: "Dribbble Jobs",
    description: "High-quality design job listings (branding, UI/product design) on Dribbble's own job board.",
    type: "Gigs",
    category: "Visual Communication",
    link: "https://dribbble.com/jobs",
    icon: "Tag",
    tags: ["Design", "Jobs"],
  },
  {
    id: "g4",
    title: "Motionographer Jobs",
    description: "Industry-standard job board for motion designers and animators (top studios and agencies post here).",
    type: "Gigs",
    category: "Motion Graphics",
    link: "https://jobs.motionographer.com/",
    icon: "Rocket",
    tags: ["Motion", "Animation"],
  },
  {
    id: "g5",
    title: "Behance Joblist",
    description: "Adobe's official creative job board. Browse design and multimedia roles worldwide (full-time and contract).",
    type: "Gigs",
    category: "Visual Communication",
    link: "https://www.behance.net/joblist",
    icon: "Star",
    tags: ["Creative", "Full-time"],
  },
  {
    id: "g6",
    title: "ArtStation Jobs",
    description: "Primary job board for 3D artists, concept artists, and game development roles.",
    type: "Gigs",
    category: "Animation & 3D Arts",
    link: "https://www.artstation.com/jobs",
    icon: "Gamepad2",
    tags: ["3D", "Gaming"],
  },
  {
    id: "g7",
    title: "Mandy Network",
    description: "Platform for film and TV production jobs (cast, crew, post-production roles).",
    type: "Gigs",
    category: "Videography",
    link: "https://www.mandy.com/",
    icon: "Clapperboard",
    tags: ["Film", "Crew"],
  },
  {
    id: "g8",
    title: "Wellfound (AngelList)",
    description: "Startup job board focused on tech/design roles at growing startups worldwide.",
    type: "Gigs",
    category: "UX/UI & Web Design",
    link: "https://wellfound.com/",
    icon: "Code2",
    tags: ["Startups", "Tech"],
  },
  {
    id: "g9",
    title: "Freelancer.com",
    description: "One of the world's largest freelance marketplaces. Hire the best freelancers for any job.",
    type: "Gigs",
    category: "Visual Communication",
    link: "https://www.freelancer.com/",
    icon: "Globe",
    tags: ["Marketplace", "All"],
  },
  {
    id: "g10",
    title: "Fiverr",
    description: "Massive marketplace of creative services (logo design, video, audio, etc.). Clients browse portfolios and buy gigs at set prices.",
    type: "Gigs",
    category: "Visual Communication",
    link: "https://www.fiverr.com/",
    icon: "ShoppingBag",
    tags: ["Marketplace", "Quick Jobs"],
  },
  {
    id: "g11",
    title: "ProductionHUB",
    description: "The global network for film, TV, and video production professionals. Find crew and vendor gigs.",
    type: "Gigs",
    category: "Videography",
    link: "https://www.productionhub.com/",
    icon: "Film",
    tags: ["Production", "Gigs"],
  },
  {
    id: "g12",
    title: "Pexels (Contributor)",
    description: "Share your high-quality photos and videos to get discovered by brands and potentially hired for custom shoots.",
    type: "Gigs",
    category: "Photography",
    link: "https://www.pexels.com/onboarding/",
    icon: "Camera",
    tags: ["Photography", "Passive Income"],
  },
  {
    id: "g13",
    title: "Twine",
    description: "Creative freelance network focused on quality briefs for designers, illustrators, and motion creatives.",
    type: "Gigs",
    category: "Visual Communication",
    link: "https://www.twine.net/",
    icon: "Briefcase",
    tags: ["Creative", "Freelance"],
    tier: "pro",
  },
  {
    id: "g14",
    title: "Working Not Working",
    description: "Invite-style creative talent network used by agencies and brands to find freelancers and full-timers.",
    type: "Gigs",
    category: "Visual Communication",
    link: "https://workingnotworking.com/",
    icon: "Star",
    tags: ["Agencies", "Creative"],
    tier: "hidden-gem",
  },
  {
    id: "g15",
    title: "Crafted",
    description: "Showcase reels and case studies, then get discovered for film, design, and motion opportunities without algorithm noise.",
    type: "Gigs",
    category: "Videography",
    link: "https://crafted.us/",
    icon: "Film",
    tags: ["Film", "Portfolio", "Gigs"],
    tier: "pro",
  },

  // COMMUNITIES
  {
    id: "c1",
    title: "Figma Community Forum",
    description: "Official forum for Figma designers – ask questions, share work, and learn from other UI/UX professionals.",
    type: "Communities",
    category: "UX/UI & Web Design",
    link: "https://forum.figma.com/",
    icon: "MessageCircle",
    tags: ["Feedback", "Design"],
  },
  {
    id: "c2",
    title: "Frontend Mentor (Community)",
    description: "Discord community for front-end developers to build real projects and get peer code/design feedback.",
    type: "Communities",
    category: "UX/UI & Web Design",
    link: "https://www.frontendmentor.io/community",
    icon: "Code2",
    tags: ["Practice", "Feedback"],
  },
  {
    id: "c3",
    title: "Blender Artists Forum",
    description: "Largest community forum for Blender users – great for 3D feedback, troubleshooting, and tutorials.",
    type: "Communities",
    category: "Animation & 3D Arts",
    link: "https://blenderartists.org/",
    icon: "Users",
    tags: ["3D", "Community"],
  },
  {
    id: "c4",
    title: "Adobe Community",
    description: "Official Adobe forums for troubleshooting and sharing tips on all Adobe tools (After Effects, Premiere, etc.).",
    type: "Communities",
    category: "Media Production",
    link: "https://community.adobe.com/",
    icon: "Globe",
    tags: ["Adobe", "Help"],
  },
  {
    id: "c5",
    title: "Motion Hatch",
    description: "Community for motion designers focusing on the business side of motion graphics. Helps creatives grow their motion design businesses.",
    type: "Communities",
    category: "Motion Graphics",
    link: "https://www.motionhatch.com/",
    icon: "Lightbulb",
    tags: ["Business", "Motion"],
    tier: "hidden-gem",
  },
  {
    id: "c6",
    title: "The Futur Pro Group",
    description: "Premium community of creative entrepreneurs. A safe space to get advice, connect with like-minded individuals, and get the accountability you need.",
    type: "Communities",
    category: "Visual Communication",
    link: "https://thefutur.com/pro-group",
    icon: "Rocket",
    tags: ["Business", "Growth"],
  },
  {
    id: "c7",
    title: "Polycount",
    description: "Community forum for 3D game artists and animators. Heavy on peer critique for game art and modeling.",
    type: "Communities",
    category: "Animation & 3D Arts",
    link: "https://polycount.com/",
    icon: "Gamepad2",
    tags: ["Gaming", "3D Art"],
  },
  {
    id: "c8",
    title: "ADPList",
    description: "Book free 1:1 mentorship with product designers, PMs, and creatives worldwide — career and portfolio feedback.",
    type: "Communities",
    category: "UX/UI & Web Design",
    link: "https://adplist.org/",
    icon: "Users",
    tags: ["Mentorship", "Career"],
    tier: "essential",
  },
  {
    id: "c9",
    title: "Designer News",
    description: "Long-running community for design news, critique threads, and industry discussion.",
    type: "Communities",
    category: "Visual Communication",
    link: "https://www.designernews.co/",
    icon: "MessageCircle",
    tags: ["News", "Discussion"],
  },

  // SCENARIOS
  {
    id: "s1",
    title: "Client Asks for Unlimited Revisions",
    description: "Always define a firm limit on revisions in your contract. Scope creep is common – set clear boundaries so you don't end up doing endless free work.",
    type: "Scenarios",
    category: "Media Production",
    link: "https://www.youtube.com/watch?v=uSma86sakPw",
    icon: "RefreshCw",
    tags: ["Scope Creep", "Contracts"],
  },
  {
    id: "s2",
    title: "Client Ghosts After Work Starts",
    description: "Always take a deposit up front and have a signed agreement before starting work. If a client goes silent, stop work until payment is made.",
    type: "Scenarios",
    category: "Visual Communication",
    link: "https://medium.com/@elizabethmjoneswrites/why-ghosting-haunts-freelancers-and-what-you-can-do-about-it-f5519faa28e4",
    icon: "Ghost",
    tags: ["Payment", "Risk"],
  },
  {
    id: "s3",
    title: "No Portfolio Yet",
    description: "Build 3–5 mock or personal projects and present them professionally. List them on Behance or your own site.",
    type: "Scenarios",
    category: "Visual Communication",
    link: "https://youtu.be/T4BpeUTFWp8?si=sOhWwkb3gxyv_x0L",
    icon: "Image",
    tags: ["Portfolio", "Beginner"],
  },
  {
    id: "s4",
    title: "Underpriced Your Work",
    description: "If a project has grown beyond the original budget/scope, renegotiate respectfully. Learning to adjust quotes or charge extra for new features is part of business sense.",
    type: "Scenarios",
    category: "UX/UI & Web Design",
    link: "https://www.linkedin.com/advice/0/what-do-you-your-project-exceeding-budget-skills-project-management-1zj5c",
    icon: "DollarSign",
    tags: ["Pricing", "Business"],
  },
  {
    id: "s5",
    title: "Too Many Clients, No System",
    description: "Use a project management system (e.g. Notion, Trello or Asana). Track deadlines, milestones and communications in one place.",
    type: "Scenarios",
    category: "Media Production",
    link: "https://www.notion.com/help/guides/category/project-management",
    icon: "LayoutDashboard",
    tags: ["Organization", "Workflow"],
  },
  {
    id: "s6",
    title: "Imposter Syndrome",
    description: "Almost every beginner feels this. Focus on improving skills and delivering client value. Finishing small projects will build confidence.",
    type: "Scenarios",
    category: "Motion Graphics",
    link: "https://www.schoolofmotion.com/blog/creative-imposter-syndrome",
    icon: "Brain",
    tags: ["Mindset", "Health"],
  },
  {
    id: "s7",
    title: "Client Disputes Final Invoice",
    description: "Protect yourself by keeping written records of scope and change requests. Track all communication and include late fees in your contract.",
    type: "Scenarios",
    category: "UX/UI & Web Design",
    link: "https://www.freeinvoicelab.com/resources/invoice-dispute-resolution-guide",
    icon: "Ban",
    tags: ["Legal", "Payment"],
  },
  {
    id: "s8",
    title: "Optimizing Render Times",
    description: "Long render times slow productivity. Learn to optimize 3D scenes (reduce polycount, bake textures, use render farms or GPU rendering).",
    type: "Scenarios",
    category: "Animation & 3D Arts",
    link: "https://gachoki.com/how-to-speed-up-cycles-render-in-blender/",
    icon: "Timer",
    tags: ["Optimization", "Rendering"],
  }
];
